import AccountBalanceRoundedIcon from '@mui/icons-material/AccountBalanceRounded';
import AccountBalanceWalletRoundedIcon from '@mui/icons-material/AccountBalanceWalletRounded';
import AdsClickRoundedIcon from '@mui/icons-material/AdsClickRounded';
import AdminPanelSettingsRoundedIcon from '@mui/icons-material/AdminPanelSettingsRounded';
import AssignmentTurnedInRoundedIcon from '@mui/icons-material/AssignmentTurnedInRounded';
import AutorenewRoundedIcon from '@mui/icons-material/AutorenewRounded';
import BoltRoundedIcon from '@mui/icons-material/BoltRounded';
import BugReportRoundedIcon from '@mui/icons-material/BugReportRounded';
import BuildRoundedIcon from '@mui/icons-material/BuildRounded';
import CalculateRoundedIcon from '@mui/icons-material/CalculateRounded';
import CampaignRoundedIcon from '@mui/icons-material/CampaignRounded';
import ConfirmationNumberRoundedIcon from '@mui/icons-material/ConfirmationNumberRounded';
import DashboardRoundedIcon from '@mui/icons-material/DashboardRounded';
import DescriptionRoundedIcon from '@mui/icons-material/DescriptionRounded';
import EditRoundedIcon from '@mui/icons-material/EditRounded';
import FactCheckRoundedIcon from '@mui/icons-material/FactCheckRounded';
import GavelRoundedIcon from '@mui/icons-material/GavelRounded';
import GppGoodRoundedIcon from '@mui/icons-material/GppGoodRounded';
import HandshakeRoundedIcon from '@mui/icons-material/HandshakeRounded';
import InsightsRoundedIcon from '@mui/icons-material/InsightsRounded';
import ListAltRoundedIcon from '@mui/icons-material/ListAltRounded';
import LocalFireDepartmentRoundedIcon from '@mui/icons-material/LocalFireDepartmentRounded';
import PaidRoundedIcon from '@mui/icons-material/PaidRounded';
import PaymentsRoundedIcon from '@mui/icons-material/PaymentsRounded';
import PeopleAltRoundedIcon from '@mui/icons-material/PeopleAltRounded';
import PlaylistRemoveRoundedIcon from '@mui/icons-material/PlaylistRemoveRounded';
import QrCode2RoundedIcon from '@mui/icons-material/QrCode2Rounded';
import ReceiptLongRoundedIcon from '@mui/icons-material/ReceiptLongRounded';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import SendRoundedIcon from '@mui/icons-material/SendRounded';
import ShoppingCartRoundedIcon from '@mui/icons-material/ShoppingCartRounded';
import ShowChartRoundedIcon from '@mui/icons-material/ShowChartRounded';
import SolarPowerRoundedIcon from '@mui/icons-material/SolarPowerRounded';
import StorageRoundedIcon from '@mui/icons-material/StorageRounded';
import StorefrontRoundedIcon from '@mui/icons-material/StorefrontRounded';
import SummarizeRoundedIcon from '@mui/icons-material/SummarizeRounded';
import SupportAgentRoundedIcon from '@mui/icons-material/SupportAgentRounded';
import TableChartRoundedIcon from '@mui/icons-material/TableChartRounded';
import TerminalRoundedIcon from '@mui/icons-material/TerminalRounded';
import VerifiedUserRoundedIcon from '@mui/icons-material/VerifiedUserRounded';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import YardRoundedIcon from '@mui/icons-material/YardRounded';
// import EmailRoundedIcon from '@mui/icons-material/EmailRounded';
import AddCommentRoundedIcon from '@mui/icons-material/AddCommentRounded';
import AddShoppingCartRoundedIcon from '@mui/icons-material/AddShoppingCartRounded';
import ArticleRoundedIcon from '@mui/icons-material/ArticleRounded';
import AssessmentRoundedIcon from '@mui/icons-material/AssessmentRounded';
import BarChartRoundedIcon from '@mui/icons-material/BarChartRounded';
import BlockRoundedIcon from '@mui/icons-material/BlockRounded';
import CancelPresentationRoundedIcon from '@mui/icons-material/CancelPresentationRounded';
import CloudUploadRoundedIcon from '@mui/icons-material/CloudUploadRounded';
import EventRepeatRoundedIcon from '@mui/icons-material/EventRepeatRounded';
import HistoryRoundedIcon from '@mui/icons-material/HistoryRounded';
import HomeWorkRoundedIcon from '@mui/icons-material/HomeWorkRounded';
import LockOpenRoundedIcon from '@mui/icons-material/LockOpenRounded';
import LoginRoundedIcon from '@mui/icons-material/LoginRounded';
import MarkEmailReadRoundedIcon from '@mui/icons-material/MarkEmailReadRounded';
import MemoryRoundedIcon from '@mui/icons-material/MemoryRounded';
import MoneyOffRoundedIcon from '@mui/icons-material/MoneyOffRounded';
import NoteAddRoundedIcon from '@mui/icons-material/NoteAddRounded';
import NotificationsActiveRoundedIcon from '@mui/icons-material/NotificationsActiveRounded';
import PlaylistAddRoundedIcon from '@mui/icons-material/PlaylistAddRounded';
import PowerSettingsNewRoundedIcon from '@mui/icons-material/PowerSettingsNewRounded';
import ReceiptRoundedIcon from '@mui/icons-material/ReceiptRounded';
import RecommendRoundedIcon from '@mui/icons-material/RecommendRounded';
import ReportProblemRoundedIcon from '@mui/icons-material/ReportProblemRounded';
import RequestQuoteRoundedIcon from '@mui/icons-material/RequestQuoteRounded';
import SentimentSatisfiedAltRoundedIcon from '@mui/icons-material/SentimentSatisfiedAltRounded';
import TaskAltRoundedIcon from '@mui/icons-material/TaskAltRounded';
import UndoRoundedIcon from '@mui/icons-material/UndoRounded';

export const MENU_SECTIONS = [
    {
        key: 'chamados',
        title: 'Chamados Internos',
        icon: AddCommentRoundedIcon,
        roles: ['Chamados', 'Adm'],
        roleIncludes: ['Atendente'],
        items: [
            { type: 'link', text: 'Novo Chamado', page: 'Chamados/abrirChamado', icon: AddCommentRoundedIcon, roles: ['Chamados', 'Adm'] },
            { type: 'link', text: 'Meus Chamados', page: 'Chamados/meusChamados', icon: ListAltRoundedIcon, roles: ['Chamados', 'Adm'] },
            { type: 'link', text: 'Atendimento Chamados', page: 'Chamados/atendimentoChamados', icon: SupportAgentRoundedIcon, roleIncludes: ['Atendente'] }
        ],
        description: '3 atalhos disponiveis'
    },
    {
        key: 'setta-servicos',
        title: 'Atendimento IA',
        icon: BuildRoundedIcon,
        roles: ['SS', 'Adm'],
        items: [
            { type: 'link', text: 'Validar Fatura', page: 'SettaServicos/validarFatura', icon: FactCheckRoundedIcon },
            { type: 'link', text: 'Enviar Mensagem', page: 'SettaServicos/enviarMensagem', icon: SendRoundedIcon },
            { type: 'link', text: 'Validar Serasa', page: 'SettaServicos/validarSerasa', icon: VerifiedUserRoundedIcon }
        ],
        description: '3 atalhos disponiveis'
    },
    {
        key: 'crm',
        title: 'CRM',
        icon: InsightsRoundedIcon,
        roles: ['CRM', 'MKT', 'Relacionamento', 'Cobranca', 'Adm'],
        items: [
            { type: 'link', text: 'Dashboard CRM', page: 'CRM/dashboard', icon: DashboardRoundedIcon, roles: ['CRM', 'Adm'] },
            { type: 'link', text: 'Marketing Dashboard', page: 'CRM/marketing-dashboard', icon: CampaignRoundedIcon, roles: ['MKT', 'Adm'] },
            { type: 'link', text: 'Conversão LPs', page: 'CRM/conversao-lps', icon: AdsClickRoundedIcon, roles: ['MKT', 'Adm'] },
            { type: 'link', text: 'Cupons', page: 'CRM/cupons', icon: ConfirmationNumberRoundedIcon, roles: ['MKT', 'Adm'] },
            { type: 'link', text: 'Indicações', page: 'CRM/indicacoes', icon: RecommendRoundedIcon, roles: ['MKT', 'Adm'] },
            { type: 'link', text: 'Leads CRM', page: 'CRM/leads', icon: PeopleAltRoundedIcon, roles: ['CRM', 'Relacionamento', 'Cobranca', 'Adm'] }
        ],
        description: '7 atalhos disponiveis'
    },
    {
        key: 'bi-ss',
        title: 'BI SS',
        icon: BarChartRoundedIcon,
        roles: ['BISS', 'Adm'],
        items: [
            { type: 'link', text: 'Extintores', page: 'BISS/extintores', icon: LocalFireDepartmentRoundedIcon },
            { type: 'link', text: 'Geração x Falhas', page: 'BISS/falhas', icon: BugReportRoundedIcon },
            { type: 'link', text: 'Controle de NRs', page: 'BISS/nrs', icon: GppGoodRoundedIcon },
            { type: 'link', text: 'Informações Técnicas', page: 'BISS/informacoesTecnicas', icon: MemoryRoundedIcon },
            { type: 'link', text: 'Informações das Usinas', page: 'BISS/informacoesUsinas', icon: HomeWorkRoundedIcon },
            { type: 'link', text: 'KPI Real x Estimado', page: 'BISS/realEstimado', icon: ShowChartRoundedIcon },
            { type: 'link', text: 'KPI Real x Estimado por Inversor', page: 'BISS/realEstimadoInversor', icon: MemoryRoundedIcon },
            { type: 'link', text: 'Relatório SPE', page: 'BISS/relatorioSpe', icon: AssessmentRoundedIcon }
        ],
        description: '8 relatorios disponiveis'
    },
    {
        key: 'bi-aluguel',
        title: 'BI Aluguel',
        icon: BarChartRoundedIcon,
        roles: ['BIGE', 'Adm'],
        landing: 'BIGE/dashboard',
        items: [
            { type: 'link', text: 'Visão Geral', page: 'BIGE/dashboard', icon: DashboardRoundedIcon },
            { type: 'link', text: 'Acessos dos Clientes', page: 'BIGE/acessosClientes', icon: LoginRoundedIcon },
            { type: 'link', text: 'Distratos', page: 'BIGE/distratos', icon: CancelPresentationRoundedIcon },
            { type: 'link', text: 'Indicações', page: 'BIGE/indicacoes', icon: RecommendRoundedIcon },
            { type: 'link', text: 'NPS', page: 'BIGE/nps', icon: SentimentSatisfiedAltRoundedIcon },
            { type: 'link', text: 'Trocas de Titularidade', page: 'BIGE/trocasTitularidade', icon: AutorenewRoundedIcon }
        ],
        description: 'Dashboard e 5 relatorios'
    },
    {
        key: 'bi-cobranca',
        title: 'BI Cobrança',
        icon: MoneyOffRoundedIcon,
        roles: ['BICOB', 'Adm'],
        landing: 'BICOB/dashboard',
        items: [
            { type: 'link', text: 'Visão Geral', page: 'BICOB/dashboard', icon: DashboardRoundedIcon },
            { type: 'link', text: 'Inadimplência', page: 'BICOB/inadimplencia', icon: MoneyOffRoundedIcon },
            { type: 'link', text: 'Acordos', page: 'BICOB/acordos', icon: HandshakeRoundedIcon },
            { type: 'link', text: 'Lista Serasa', page: 'BICOB/listaSerasa', icon: RequestQuoteRoundedIcon },
            { type: 'link', text: 'Situação Inadimplentes', page: 'BICOB/situacaoInadimplentes', icon: WarningAmberRoundedIcon }
        ],
        description: 'Dashboard e 4 relatorios'
    },
    {
        key: 'parceiro',
        title: 'Parceiro',
        icon: HandshakeRoundedIcon,
        roles: ['MKT', 'Influencer', 'Adm'],
        items: [
            { type: 'link', text: 'Parceiro', page: 'parceiro/dashboard', icon: HandshakeRoundedIcon }
        ],
        description: '1 atalho disponivel'
    },
    {
        key: 'oem',
        title: 'O&M',
        icon: BuildRoundedIcon,
        roles: ['OeM', 'Adm'],
        items: [
            { type: 'link', text: 'Inserir Falhas', page: 'OeM/inserirFalhas', icon: BugReportRoundedIcon },
            { type: 'link', text: 'Inserir Geração', page: 'OeM/inserirGeracao', icon: SolarPowerRoundedIcon },
            { type: 'link', text: 'Substituir Inversor', page: 'OeM/substituirInversor', icon: AutorenewRoundedIcon },
            { type: 'link', text: 'Atualizar Extintores', page: 'OeM/atualizarExtintores', icon: LocalFireDepartmentRoundedIcon },
            { type: 'link', text: 'Atualizar NRs', page: 'OeM/atualizarNRs', icon: GppGoodRoundedIcon },
            { type: 'link', text: 'Atualizar Vegetação', page: 'OeM/atualizarVegetacao', icon: YardRoundedIcon },
            { type: 'link', text: 'Relatorio SPEs', page: 'OeM/criarRelatorioSPEs', icon: SummarizeRoundedIcon },
            { type: 'link', text: 'Alertas PV OP', page: 'OeM/alertasPVOPeration', icon: WarningAmberRoundedIcon },
            { type: 'link', text: 'Desativar/Reativar Inversor', page: 'OeM/desativarReativarInversor', icon: PowerSettingsNewRoundedIcon },
            { type: 'link', text: 'Obter Logs Monitoramento', page: 'OeM/logsMonitoramento', icon: TerminalRoundedIcon }
        ],
        description: '10 atalhos disponiveis'
    },
    {
        key: 'cobranca',
        title: 'Cobrança',
        icon: CampaignRoundedIcon,
        roles: ['Cobranca', 'Adm'],
        items: [
            { type: 'link', text: 'Gerar Pix', page: 'Cobranca/gerarPix', icon: QrCode2RoundedIcon },
            { type: 'link', text: 'Simular Acordo', page: 'Cobranca/simularAcordo', icon: CalculateRoundedIcon },
            { type: 'link', text: 'Lancar Acordo', page: 'Cobranca/lancarAcordo', icon: AssignmentTurnedInRoundedIcon },
            { type: 'link', text: 'Relatorio Serasa', page: 'Cobranca/checkSerasaCobranca', icon: SearchRoundedIcon },
            { type: 'link', text: 'Negativar Títulos', page: 'Cobranca/negativarTitulo', icon: BlockRoundedIcon },
            { type: 'link', text: 'Quitação de Débitos', page: 'Cobranca/quitacaoDebitos', icon: TaskAltRoundedIcon },
            { type: 'link', text: 'Recebimento LITIGIO', page: 'Cobranca/lancarAcordoLitigio', icon: GavelRoundedIcon },
            { type: 'link', text: 'Recebimento Limpa Nome', page: 'Cobranca/recebimentoLimpaNome', icon: PaidRoundedIcon },
            { type: 'link', text: 'Gerar PIX LITIGIO', page: 'Cobranca/gerarPixLitigio', icon: QrCode2RoundedIcon },
            { type: 'link', text: 'Cancelar Acordo', page: 'Cobranca/cancelarAcordo', icon: PlaylistRemoveRoundedIcon },
            { type: 'link', text: 'Cobrar Multa', page: 'Relacionamento/cobrarMulta', icon: ReportProblemRoundedIcon }
        ],
        description: '11 atalhos disponiveis'
    },
    {
        key: 'relacionamento',
        title: 'Relacionamento',
        icon: HandshakeRoundedIcon,
        roles: ['Relacionamento', 'Adm'],
        items: [
            { type: 'link', text: 'Desfazer Distrato', page: 'Relacionamento/desfazerDistrato', icon: UndoRoundedIcon },
            { type: 'link', text: 'Adicionar Aditivo ou CC', page: 'Relacionamento/addAdditiveCC', icon: PlaylistAddRoundedIcon },
            { type: 'link', text: 'Quitação de Débitos', page: 'Relacionamento/quitacaoDebitos', icon: TaskAltRoundedIcon },
            { type: 'link', text: 'Desligamento', page: 'Relacionamento/desligamentoDefinitivo', icon: PowerSettingsNewRoundedIcon },
            { type: 'link', text: 'Cobrar Multa', page: 'Relacionamento/cobrarMulta', icon: ReportProblemRoundedIcon },
            { type: 'link', text: 'Solicitar Reembolso', page: 'Relacionamento/solicitacaoReembolso', icon: RequestQuoteRoundedIcon },
            { type: 'link', text: 'Contestar Fatura', page: 'Relacionamento/contestacaoFaturas', icon: ReportProblemRoundedIcon },
            { type: 'link', text: 'Procuração de Contestação', page: 'Relacionamento/gerarProcuracaoContestacao', icon: ArticleRoundedIcon },
            { type: 'link', text: 'Notificar Cliente', page: 'Relacionamento/notificarCliente', icon: NotificationsActiveRoundedIcon },
            { type: 'link', text: 'E-mail Verificação', page: 'Relacionamento/emailVerificacao', icon: MarkEmailReadRoundedIcon }
        ],
        description: '10 atalhos disponiveis'
    },
    {
        key: 'protocolos',
        title: 'Protocolos',
        icon: DescriptionRoundedIcon,
        roles: ['Protocolos', 'Adm'],
        items: [
            { type: 'link', text: 'Inserir Protocolos', page: 'Protocolos/inserirProtocolos', icon: NoteAddRoundedIcon },
            { type: 'link', text: 'Finalizar Protocolos', page: 'Protocolos/finalizarProtocolo', icon: TaskAltRoundedIcon },
            { type: 'link', text: 'Prorrogar Protocolos', page: 'Protocolos/prorrogarProtocolo', icon: EventRepeatRoundedIcon }
        ],
        description: '3 atalhos disponiveis'
    },
    {
        key: 'ge',
        title: 'GE',
        icon: BoltRoundedIcon,
        roles: ['GE', 'Adm'],
        items: [
            { type: 'link', text: 'Calcular Aluguel', page: 'GestaoEnergia/calcularAluguel', icon: CalculateRoundedIcon },
            { type: 'link', text: 'Faturar Cliente', page: 'GestaoEnergia/faturarCliente', icon: PaymentsRoundedIcon },
            { type: 'link', text: 'Cadastrar CC Consórcio', page: 'GestaoEnergia/cadastrarCC', icon: PlaylistAddRoundedIcon },
            { type: 'link', text: 'Informar Débitos', page: 'GestaoEnergia/informarDebitos', icon: ListAltRoundedIcon },
            { type: 'link', text: 'Contestar Fatura', page: 'GestaoEnergia/contestacaoFaturas', icon: ReportProblemRoundedIcon },
            { type: 'link', text: 'Excedentes UG', page: 'GestaoEnergia/excedentesUG', icon: ShowChartRoundedIcon },
            { type: 'link', text: 'Criar Contrato', page: 'GestaoEnergia/criarContrato', icon: ArticleRoundedIcon },
            { type: 'link', text: 'Listar CCs', page: 'GestaoEnergia/listarCCsConsorcio', icon: ListAltRoundedIcon },
            { type: 'link', text: 'Fechamento do Consórcio', page: 'GestaoEnergia/fechamentoConsorcio', icon: SummarizeRoundedIcon },
            // { type: 'link', text: 'E-mail Troca de Titularidade', page: 'GestaoEnergia/emailTrocaTitularidade', icon: EmailRoundedIcon },
            { type: 'link', text: 'Aluguel Mataraca', page: 'GestaoEnergia/aluguelMataraca', icon: PaymentsRoundedIcon },
            { type: 'link', text: 'Solicitar Comprovante', page: 'GestaoEnergia/solicitarComprovante', icon: ReceiptRoundedIcon },
            { type: 'link', text: 'Senha PDF', page: 'GestaoEnergia/decryptPDF', icon: LockOpenRoundedIcon },
            { type: 'link', text: 'Troca Agência', page: 'GestaoEnergia/trocaAgencia', icon: AutorenewRoundedIcon },
            { type: 'link', text: 'Carta TOI', page: 'GestaoEnergia/cartaTOI', icon: DescriptionRoundedIcon }
        ],
        description: '14 atalhos disponiveis'
    },
    {
        key: 'faturamento',
        title: 'Faturamento',
        icon: ReceiptLongRoundedIcon,
        roles: ['Faturamento', 'Adm'],
        items: [
            { type: 'action', action: 'lerFaturasNeoenergia', text: 'Leitura de Faturas', icon: FactCheckRoundedIcon },
            { type: 'action', action: 'gerarContasPagar', text: 'CSV Pagar', icon: PaymentsRoundedIcon },
            { type: 'link', text: 'Gerar CSV Faturamento', page: 'Faturamento/gerarCSVFaturamento', icon: TableChartRoundedIcon },
            { type: 'link', text: 'Alterar Projeto', page: 'Faturamento/alterarProjeto', icon: EditRoundedIcon },
            { type: 'link', text: 'Ajuste Entre Projetos', page: 'Faturamento/ajusteProjetoConsorcio', icon: EditRoundedIcon },
            { type: 'link', text: 'Atualizar Projeto UGs', page: 'Faturamento/atualizarProjetoGeradora', icon: AutorenewRoundedIcon },
            { type: 'link', text: 'Lancamento SPEs', page: 'Faturamento/lancamentoSPE', icon: StorageRoundedIcon },
            { type: 'link', text: 'Retenção de Caixa SPE', page: 'Faturamento/retencaoCaixaSPE', icon: AccountBalanceWalletRoundedIcon },
            { type: 'link', text: 'Listar Débitos', page: 'Faturamento/listarDebitos', icon: ListAltRoundedIcon }
        ],
        description: '9 atalhos disponiveis'
    },
    {
        key: 'financeiro',
        title: 'Financeiro',
        icon: PaidRoundedIcon,
        roles: ['Financeiro', 'Adm'],
        items: [
            { type: 'link', text: 'Faturar Cliente', page: 'Financeiro/faturarCliente', icon: PaymentsRoundedIcon },
            { type: 'link', text: 'Criar Contrato', page: 'Financeiro/criarContrato', icon: ArticleRoundedIcon },
            { type: 'link', text: 'Gerar Pix', page: 'Financeiro/gerarPix', icon: QrCode2RoundedIcon },
            { type: 'link', text: 'Quitação de Debitos', page: 'Financeiro/quitacaoDebitos', icon: TaskAltRoundedIcon },
            { type: 'link', text: 'Relatório Serasa', page: 'Financeiro/checkSerasaCobranca', icon: SearchRoundedIcon },
            { type: 'link', text: 'Lancamento SPEs', page: 'Financeiro/lancamentoSPE', icon: StorageRoundedIcon },
            { type: 'link', text: 'Retenção de Caixa SPE', page: 'Financeiro/retencaoCaixaSPE', icon: AccountBalanceWalletRoundedIcon },
            { type: 'link', text: 'Lançar Reembolso', page: 'Financeiro/lancarReembolso', icon: RequestQuoteRoundedIcon },
            { type: 'link', text: 'Lançar Pagamentos Bradesco', page: 'Financeiro/lancarPagamentosBradesco', icon: AccountBalanceWalletRoundedIcon }
        ],
        description: '11 atalhos disponiveis'
    },
    {
        key: 'litigio',
        title: 'Litígio',
        icon: GavelRoundedIcon,
        roles: ['Litigio', 'Adm'],
        items: [
            { type: 'link', text: 'Recebimento LITIGIO', page: 'Cobranca/lancarAcordoLitigio', icon: GavelRoundedIcon },
            { type: 'link', text: 'Gerar PIX LITIGIO', page: 'Cobranca/gerarPixLitigio', icon: QrCode2RoundedIcon }
        ],
        description: '2 atalhos disponiveis'
    },
    {
        key: 'comercial',
        title: 'Comercial',
        icon: StorefrontRoundedIcon,
        roles: ['Comercial', 'Adm'],
        items: [
            { type: 'link', text: 'Notificar Cliente', page: 'Comercial/notificarCliente', icon: NotificationsActiveRoundedIcon, roles: ['Comercial', 'Adm'] },
            { type: 'link', text: 'E-mail Verificação', page: 'Comercial/emailVerificacao', icon: MarkEmailReadRoundedIcon, roles: ['Comercial', 'Adm'] },
            { type: 'link', text: 'Listar Distratos', page: 'Faturamento/listarDistratos', icon: CancelPresentationRoundedIcon, roles: ['Comercial', 'Adm'] },
            { type: 'link', text: 'Proposta PJ', page: 'Comercial/gerarProposta', icon: RequestQuoteRoundedIcon, roles: ['Comercial', 'Interno', 'Adm'] }
        ],
        description: '4 atalhos disponiveis'
    },
    {
        key: 'serasa',
        title: 'Serasa',
        icon: AdminPanelSettingsRoundedIcon,
        roles: ['Serasa', 'Adm'],
        items: [
            { type: 'link', text: 'Aprovar Serasa', page: 'Comercial/aprovarSerasa', icon: VerifiedUserRoundedIcon }
        ],
        description: '1 atalho disponivel'
    },
    {
        key: 'consultor',
        title: 'Consultor Comercial',
        icon: SupportAgentRoundedIcon,
        roles: ['Consultor', 'Adm'],
        items: [
            { type: 'link', text: 'Proposta Digital', page: 'Consultor/gerarProposta', icon: RequestQuoteRoundedIcon }
        ],
        description: '1 atalho disponivel'
    },
    {
        key: 'pedidos-oem',
        title: 'Pedidos OeM',
        icon: ShoppingCartRoundedIcon,
        roles: ['PedidosOeM', 'Adm'],
        items: [
            { type: 'link', text: 'Adicionar Material', page: 'PedidosOeM/novoMaterial', icon: PlaylistAddRoundedIcon, roles: ['PedidosOeMGerencial', 'Adm'] },
            { type: 'link', text: 'Novo Pedido', page: 'PedidosOeM/novoPedido', icon: AddShoppingCartRoundedIcon },
            { type: 'link', text: 'Histórico de Pedidos', page: 'PedidosOeM/historicoPedidos', icon: HistoryRoundedIcon }
        ],
        description: '3 atalhos disponiveis'
    },
    {
        key: 'ri',
        title: 'RI',
        icon: AccountBalanceRoundedIcon,
        roles: ['RI', 'Adm'],
        items: [
            { type: 'link', text: 'Atualizar Relatorio SPE', page: 'RI/atualizarRelatorioInvestidor', icon: CloudUploadRoundedIcon },
            { type: 'link', text: 'DRE por Projeto', page: 'RI/dreProjetos', icon: ReceiptLongRoundedIcon },
            { type: 'link', text: 'Fechamento do Consórcio', page: 'RI/fechamentoConsorcio', icon: SummarizeRoundedIcon }
        ],
        description: '3 atalhos disponiveis'
    }
];

export const hasMenuAccess = (item = {}, autorizacoes = []) => {
    const hasRole = item.roles?.some((role) => autorizacoes.includes(role)) || false;
    const hasRoleIncludes = item.roleIncludes?.some((role) =>
        autorizacoes.some((autorizacao) => autorizacao.includes(role))) || false;
    const hasNoRoleRestriction = !item.roles && !item.roleIncludes;

    return autorizacoes.includes('Adm') || hasNoRoleRestriction || hasRole || hasRoleIncludes;
};
export const getVisibleItems = (items = [], autorizacoes = []) => items
    .filter((item) => hasMenuAccess(item, autorizacoes));

export const getVisibleSections = (autorizacoes = []) => MENU_SECTIONS
    .filter((section) => hasMenuAccess(section, autorizacoes))
    .filter((section) => getVisibleItems(section.items, autorizacoes).length > 0);

export const getSectionPath = (section) => (
    section.landing ? `/${section.landing}` : `/menu/${section.key}`
);

export const getSectionByKey = (key) => {
    return MENU_SECTIONS.find((item) => item.key === key) || null;
};

const normalizePath = (value = '') => value.replace(/^\//, '').toLowerCase();

const getSectionByNormalizedKey = (key) => {
    return MENU_SECTIONS.find((item) => item.key.toLowerCase() === key) || null;
};

export const getSectionKeyByPath = (pathname = '/') => {
    if (pathname === '/') {
        return 'home';
    }

    const currentPath = normalizePath(pathname);

    if (currentPath.startsWith('menu/')) {
        const sectionKey = currentPath.replace('menu/', '');
        return getSectionByNormalizedKey(sectionKey)?.key || sectionKey;
    }

    for (const section of MENU_SECTIONS) {
        for (const item of section.items) {
            if (!item.page) continue;

            const itemPath = normalizePath(item.page);

            if (itemPath === currentPath || currentPath.startsWith(`${itemPath}/`)) {
                return section.key;
            }
        }
    }

    for (const section of MENU_SECTIONS) {
        const sectionPrefix = normalizePath(section.items.find((item) => item.page)?.page || '').split('/')[0];

        if (sectionPrefix && currentPath.startsWith(`${sectionPrefix}/`)) {
            return section.key;
        }
    }

    return '';
};

export const getPageHeaderByPath = (pathname = '/') => {
    if (pathname === '/') {
        return { title: 'SETTA CORPORATIVO', icon: null, eyebrow: 'Home' };
    }

    if (pathname === '/403-Unauthorized') {
        return { title: 'Acesso negado', icon: null, eyebrow: 'Permissoes' };
    }

    const currentPath = normalizePath(pathname);

    if (currentPath.startsWith('menu/')) {
        const sectionKey = currentPath.replace('menu/', '');
        const section = getSectionByNormalizedKey(sectionKey);

        if (section) {
            return { title: section.title, icon: section.icon, eyebrow: 'Area' };
        }
    }

    for (const section of MENU_SECTIONS) {
        for (const item of section.items) {
            if (item.page && normalizePath(item.page) === currentPath) {
                return {
                    title: item.text,
                    icon: item.icon || section.icon,
                    eyebrow: section.title
                };
            }
        }
    }

    for (const section of MENU_SECTIONS) {
        const sectionPrefix = normalizePath(section.items.find((item) => item.page)?.page || '').split('/')[0];

        if (sectionPrefix && currentPath.startsWith(`${sectionPrefix}/`)) {
            return { title: section.title, icon: section.icon, eyebrow: 'Area' };
        }
    }

    return { title: 'Setta Corporativo', icon: null, eyebrow: 'Operacao' };
};
